import React from 'react'

import './background.css'

export function Mascots () {
  return (
      <img alt='' className='background-mascots' src={"https://static.prod.pokemon.com/images/starter_mascots.png"} />
  )
}
